import ServiceApi from '../ServiceApi';
import UtilResponseException from "../../utils/UtilResponseException";

/** Сервис для сохранения ранее введенных параметров */
export default class ServiceInputStore {
    /**
     * Название микросервиса для запросов
     * @private
     * @static
     * @type {String}
     */
    static _microserviceName = 'free';

    /**
     * @private
     * @static
     * @type {Object}
     * @property {String} _requestRoute
     */
    static _requestRoute = '/input-store/';

    static async list(source = '') {
        try {
            const response = await ServiceApi.get(this._microserviceName, this._requestRoute + source);
            const {data: {data = []}} = response;
            return data
        }
        catch(error) {
            console.log(error);
            throw new Error(UtilResponseException.getMessage(error));
        }
    }

    static async select(source = '', value = '') {
        try {
            const response = await ServiceApi.put(
                this._microserviceName,
                this._requestRoute + source,
                {value}
            );
            const {data: {data = {}}} = response;
            return data
        }
        catch(error) {
            console.log(error);
            throw new Error(UtilResponseException.getMessage(error));
        }
    }

    static async delete(valueId) {
        try {
            await ServiceApi.delete(this._microserviceName, this._requestRoute + valueId);
            return true;
        }
        catch(error) {
            console.log(error);
            throw new Error(UtilResponseException.getMessage(error));
        }
    }
}
